import { getAuthHeader } from "@/auth/authToken";

const normalizeBaseUrl = (url) => (url || "").replace(/\/+$/, "");
const DEFAULT_ASSISTANT_BASE = "https://api.dev.theharrispoll.dev/ai-assistant";

export const getAssistantBaseUrl = () => {
  const envBase = import.meta.env.VITE_ASSISTANT_URL;
  let base = envBase || DEFAULT_ASSISTANT_BASE;

  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    base = base.replace(/^http:\/\//i, "https://");
  }

  return normalizeBaseUrl(base);
};

export const buildAssistantUrl = (path = "") => {
  const base = getAssistantBaseUrl();
  const cleaned = String(path || "").replace(/^\/+/, "");
  return `${base}/${cleaned}`;
};

/**
 * Headers for an assistant request, including the bearer token.
 *
 * The token comes from `getAuthHeader` rather than from `localStorage` because
 * that is the seam the rest of the app uses, and it is the only thing that
 * knows where the token actually lives. Under Auth0 the SPA SDK keeps it in
 * its own cache, keyed by client id and audience, and refreshes it on its own
 * schedule -- there is no `token` key to read, so reading one returned null
 * and every assistant request went out unauthenticated for a 401.
 *
 * Async for the same reason: the SDK may have to renew an expired token
 * before it can answer, and that is a round trip.
 *
 * A caller that passes its own `Authorization` keeps it. The scheme is
 * normalised because the two modes differ -- `getAuthHeader` returns a
 * prefixed header under Auth0 and a bare token without it.
 */
export const buildAssistantHeaders = async (extra = {}) => {
  const headers = { ...extra };
  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization) {
    const auth = await getAuthHeader();
    if (auth) {
      headers.Authorization = auth.startsWith("Bearer ") ? auth : `Bearer ${auth}`;
    }
  }
  return headers;
};
